const common = {
  siteName: "四虎影视大全",
  siteDescription: "四虎影视大全电视剧全集频道，提供热门剧集、最新电视剧免费全集在线观看，无需逐集寻找，一次性畅享完整剧情。",
  nav: {
    home: "首页",
    categories: "分类",
    about: "关于我们",
    search: "搜索电视剧...",
  },
  home: {
    heroTitle: "四虎影视大全",
    heroSubtitle: "电视剧全集在线观看 · 免费全集一网打尽",
    heroDesc: "热门剧集、最新电视剧免费全集，无需逐集寻找，一次性畅享完整剧情",
    heroCta: "立即观看",
    featuredTitle: "热门推荐",
    featuredDesc: "精选口碑佳作，好评如潮的电视剧推荐",
    categoriesTitle: "剧集分类",
    categoriesDesc: "按类型浏览，快速找到你想看的电视剧",
    latestTitle: "最近更新",
    latestDesc: "最新上线的热门电视剧全集",
    viewAll: "查看全部",
  },
  category: {
    title: "剧集分类",
    allCategories: "全部分类",
    totalResults: "共 {{count}} 部作品",
    noResults: "该分类下暂无内容",
    episodes: "集",
    watchNow: "立即观看",
  },
  article: {
    director: "导演",
    actors: "主演",
    region: "地区",
    language: "语言",
    episodes: "集数",
    status: "状态",
    rating: "评分",
    year: "年份",
    tags: "标签",
    episodeList: "分集列表",
    description: "剧情简介",
    backToList: "返回列表",
    duration: "时长",
  },
  about: {
    title: "关于我们",
    brandTitle: "品牌介绍",
    brandDesc1: "四虎影视大全成立于2020年，是国内领先的电视剧在线观看平台。我们以「让每个人都能轻松享受优质影视内容」为使命，致力于为用户提供最全面、最便捷的电视剧全集观看服务。",
    brandDesc2: "经过多年的发展，四虎影视大全已成为覆盖国产剧、韩剧、美剧、日剧、动漫、综艺、纪录片等多个品类的综合性影视平台，月活跃用户超过千万，深受广大追剧爱好者的喜爱与信赖。",
    reputationTitle: "用户口碑",
    reputationDesc: "听听我们的用户怎么说",
    contactTitle: "联系我们",
    contactDesc: "如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们联系。我们的团队将在24小时内回复您的消息。",
    email: "电子邮箱",
    emailValue: "contact@sihutv.com",
    wechat: "微信公众号",
    wechatValue: "四虎影视大全",
    weibo: "官方微博",
    weiboValue: "@四虎影视大全",
    address: "公司地址",
    addressValue: "北京市朝阳区建国路88号SOHO现代城A座",
    phone: "客服电话",
    phoneValue: "400-888-6666",
    statsUsers: "累计用户",
    statsSeries: "收录剧集",
    statsCategories: "剧集分类",
    statsSatisfaction: "用户满意度",
  },
  footer: {
    copyright: "© 2024 四虎影视大全 版权所有",
    about: "关于我们",
    privacy: "隐私政策",
    terms: "使用条款",
    contact: "联系我们",
  },
  breadcrumb: {
    home: "首页",
    category: "分类",
    about: "关于我们",
  },
  schema: {
    organizationName: "四虎影视大全",
    organizationDescription: "四虎影视大全 - 国内领先的电视剧全集免费在线观看平台，提供国产剧、韩剧、美剧、日剧、动漫、综艺、纪录片等全品类影视资源。",
  },
};

export default common;